import { Controller } from '@hotwired/stimulus';

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import app from 'domains/application';
import canvases from 'domains/canvases';
import navigation from 'domains/navigation';

import Wos from 'components/apps/Wos';
import store from 'store/wos_store';

// Connects to data-controller="cart-renderer"
export default class extends Controller {
  connect() {
    this.render();
  }

  render() {
    store.dispatch(app.actions.initApp());
    store.dispatch(canvases.actions.addCanvas({}));
    store.dispatch(navigation.actions.initializeNavigation({ cart: true }));

    return render(
      <Provider store={store}>
        <Wos />
      </Provider>,
      this.element
    );
  }
}
